<template>
    <div class="live-detail-component">
        <market-view-live-detail-v5></market-view-live-detail-v5>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import MarketViewLiveDetailV5 from "./Live/MarketViewLiveDetailV5.vue";

    export default {
        name: 'LiveDetail',
        components: {
            MarketViewLiveDetailV5
        },
        data: () => ({}),
        computed: {
            ...mapGetters({
                // 'getGameConsole': 'settings/getGameConsole',
                // 'getPlatformId': 'settings/getPlatformId'
            }),
        },
    };
</script>

<style>

</style>
